import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	itemArchives: {
		id: 'spa-apps-sidebar-software-classic.menu.item-archives',
		defaultMessage: 'Archived issues',
		description: '"Archived issues" menu item.',
	},
	backlogItem: {
		id: 'spa-apps-sidebar-software-classic.menu.backlog-item',
		defaultMessage: 'Backlog',
		description: 'Navigation item which links to a backlog page in software project',
	},
	scrumBoard: {
		id: 'spa-apps-sidebar-software-classic.menu.scrum-board',
		defaultMessage: 'Active sprints',
		description: 'Navigation item which links to a scrum board page in software project',
	},
	kanbanBoard: {
		id: 'spa-apps-sidebar-software-classic.menu.kanban-board',
		defaultMessage: 'Kanban board',
		description: 'Navigation item which links to a kanban board page in software project',
	},
	backItem: {
		id: 'spa-apps-sidebar-software-classic.menu.back-item',
		defaultMessage: 'Back to project',
		description: 'Back to project menu item.',
	},
	reportsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.reports-item',
		defaultMessage: 'Reports',
		description: 'Navigation item which links to or from a reports page in a software project',
	},
	timelineItem: {
		id: 'spa-apps-sidebar-software-classic.menu.timeline-item',
		defaultMessage: 'Timeline',
		description: 'Navigation item which links to timelines in a software project',
	},
	calendarItem: {
		id: 'spa-apps-sidebar-software-classic.menu.calendar-item',
		defaultMessage: 'Calendar',
		description: 'Navigation item which links to calendar view in a software project',
	},
	listItem: {
		id: 'spa-apps-sidebar-software-classic.menu.list-item',
		defaultMessage: 'List',
		description: 'Navigation item which links to list in a software project',
	},
	codeItem: {
		id: 'spa-apps-sidebar-software-classic.menu.code-item',
		defaultMessage: 'Code',
		description:
			'Navigation item to go to Code page. Code page is to manage/link between Jira project and programming code repository. See how the actual code is associated with the project.',
	},
	formsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.forms-item',
		defaultMessage: 'Forms',
		description:
			'The text is shown as a classic software project Navigation item where it triggers the Forms page. Optimal characters is 18 or less.',
	},
	goalsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.goals-item',
		defaultMessage: 'Goals',
		description: 'Navigation item to go to Goals page',
	},
	projectSettingsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.project-settings-item',
		defaultMessage: 'Project settings',
		description: 'Navigation item which links to project settings in a software project',
	},
	securityItem: {
		id: 'spa-apps-sidebar-software-classic.menu.security-item',
		defaultMessage: 'Security',
		description: 'Navigation item to go to Security page.',
	},
	summaryItem: {
		id: 'spa-apps-sidebar-software-classic.menu.summary-item',
		defaultMessage: 'Summary',
		description: 'Navigation item to go to Summary page.',
	},
	releasesItem: {
		id: 'spa-apps-sidebar-software-classic.menu.releases-item',
		defaultMessage: 'Releases',
		description: 'Releases in a classic software project.',
	},
	periscopeItemNonFinal: {
		id: 'spa-apps-sidebar-software-classic.menu.periscope-item-non-final',
		defaultMessage: 'Development',
		description: 'Navigation item which is the title of work suggestions page sidebar',
	},
	pinItem: {
		id: 'spa-apps-sidebar-software-classic.menu.pin-item',
		defaultMessage: 'Issues and filters',
		description: 'Issues and filters in a classic software project.',
	},
	ninItem: {
		id: 'spa-apps-sidebar-software-classic.menu.nin-item',
		defaultMessage: 'Issues',
		description: 'Issues in a classic software project.',
	},
	newNinNestedMenuItemTitleHeader: {
		id: 'spa-apps-sidebar-software-classic.menu.new-nin-nested-menu-item-title-header',
		defaultMessage: 'Default Filters',
		description: 'Heading text to denote the list of filters dedicated sidebar for NIN.',
	},
	pagesItem: {
		id: 'spa-apps-sidebar-software-classic.menu.pages-item',
		defaultMessage: 'Pages',
		description: 'Pages in a classic software project.',
	},
	opsgenieItem: {
		id: 'spa-apps-sidebar-software-classic.menu.opsgenie-item',
		defaultMessage: 'On-call',
		description: 'On-call schedule in a classic software project.',
	},
	whoIsOnCall: {
		id: 'spa-apps-sidebar-software-classic.menu.who-is-on-call',
		defaultMessage: 'On-call',
		description: 'Navigation item which links to cross flow dialog for Opsgenie',
	},
	componentsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.components-item',
		defaultMessage: 'Components',
		description: 'Components in a classic software project.',
	},
	beta: {
		id: 'spa-apps-sidebar-software-classic.menu.beta',
		defaultMessage: 'Beta',
		description:
			'Beta lozenge shows on navigation. Indicate that the feature is still in early stages.',
	},
	alpha: {
		id: 'spa-apps-sidebar-software-classic.menu.alpha',
		defaultMessage: 'Alpha',
		description:
			'Alpha lozenge shows on navigation. Indicate that the feature is still in early stages.',
	},
	new: {
		id: 'spa-apps-sidebar-software-classic.menu.new',
		defaultMessage: 'New',
		description: 'New lozenge shows on navigation. Indicate that the feature is new.',
	},
	recommended: {
		id: 'spa-apps-sidebar-software-classic.menu.recommended',
		defaultMessage: 'Recommended',
		description: 'Recommended lozenge shows on navigation.',
	},
	atlassianIntelligence: {
		id: 'spa-apps-sidebar-software-classic.menu.atlassian-intelligence',
		defaultMessage: 'AI',
		description:
			'New lozenge shows on navigation. Indicate that the feature is now powered by atlassian intelligence.',
	},
	// Rebranded
	headerDescriptionCompanyManaged: {
		id: 'spa-apps-sidebar-software-classic.menu.header-description-company-managed',
		defaultMessage: 'Software project',
		description: 'Project type description in a classic software project.',
	},
	planningModule: {
		id: 'spa-apps-sidebar-software-classic.menu.planning-module',
		defaultMessage: 'PLANNING',
		description: 'Planning module section title in a classic software project.',
	},
	developmentModule: {
		id: 'spa-apps-sidebar-software-classic.menu.development-module',
		defaultMessage: 'DEVELOPMENT',
		description: 'Development module section title in a classic software project.',
	},
	operationsModule: {
		id: 'spa-apps-sidebar-software-classic.menu.operations-module',
		defaultMessage: 'OPERATIONS',
		description: 'Operations module section title in a classic software project.',
	},
	incidentsItem: {
		id: 'spa-apps-sidebar-software-classic.menu.incidents-item',
		defaultMessage: 'Incidents',
		description: 'Navigation item to go to the Incidents page.',
	},
	itemArchivesIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.item-archives-issue-term-refresh',
		defaultMessage: 'Archived work items',
		description: 'Archived work items in a classic software project.',
	},
	ninItemIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.nin-item-issue-term-refresh',
		defaultMessage: 'All work',
		description: 'Work items in a classic software project.',
	},
	pinItemIssueTermRefresh: {
		id: 'spa-apps-sidebar-software-classic.menu.pin-item-issue-term-refresh',
		defaultMessage: 'Work items and filters',
		description: 'Issues and filters in a classic software project.',
	},
});
